'use strict';
import * as $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c from "./internal-9eb04c7a932b923c3bc5eb25fd6219ee930b689c.js";
var $p;
/** @constructor */
function $c_Lmealorama_RecipeSortType() {
}
export { $c_Lmealorama_RecipeSortType as $c_Lmealorama_RecipeSortType };
$p = $c_Lmealorama_RecipeSortType.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$p.constructor = $c_Lmealorama_RecipeSortType;
/** @constructor */
function $h_Lmealorama_RecipeSortType() {
}
export { $h_Lmealorama_RecipeSortType as $h_Lmealorama_RecipeSortType };
$h_Lmealorama_RecipeSortType.prototype = $p;
$p.v = (function() {
  return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Product$$anon$1(this);
});
var $d_Lmealorama_RecipeSortType = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().i(0, "mealorama.RecipeSortType", ({
  jQ: 1,
  b: 1,
  c: 1,
  a: 1,
  l: 1
}));
export { $d_Lmealorama_RecipeSortType as $d_Lmealorama_RecipeSortType };
//# sourceMappingURL=mealorama.-Recipe-Sort-Type.js.map
